export * from './parametro-dispositivo.service';
export * from './parametro-portal.service';
export * from './parametro-administrativo.service';
export * from './entregas.service';
export * from './carregamento.service';
export * from './carregamento-entrega-inativo.service';
export * from './ajudante.service';
export * from './motivo-cancelamento.service';
export * from './motoristas.service';
export * from './nivel-servico-logistico.service';
export * from './localizacao-motorista.service';
export * from './painel-monitoramento.service';
export * from './filial.service';
export * from './relatorios';
export * from './usuarios.service';
export * from './usuario-rota.service';
export * from './rota.service';